/*
 * J4U product lightbox zoom v1.3
 * Adds high-resolution multi-step zoom, mouse-wheel zoom, drag/pan,
 * touch pinch zoom and keyboard controls to this theme's product lightbox.
 */
(function(window, document) {
  'use strict';

  var MIN_SCALE = 1;
  var ABSOLUTE_MAX_SCALE = 4;
  var SCALE_STEP = 0.5;
  var active = null;
  var scanFrame = null;
  var themeJQuery = window.jQuery;
  var requestFrame = window.requestAnimationFrame || function(callback) {
    return window.setTimeout(callback, 16);
  };
  var cancelFrame = window.cancelAnimationFrame || function(frameId) {
    window.clearTimeout(frameId);
  };

  function now() {
    return Date.now ? Date.now() : new Date().getTime();
  }

  function clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
  }

  function distance(a, b) {
    var dx = a.x - b.x;
    var dy = a.y - b.y;
    return Math.sqrt(dx * dx + dy * dy);
  }

  function center(a, b) {
    return {
      x: (a.x + b.x) / 2,
      y: (a.y + b.y) / 2
    };
  }

  function imageSource(img) {
    return img.currentSrc || img.src || '';
  }

  function getViewport(state) {
    var rect = state.figure.getBoundingClientRect();
    return {
      x: rect.left + rect.width / 2,
      y: rect.top + rect.height / 2,
      width: rect.width,
      height: rect.height
    };
  }

  function calculateMaxScale(state) {
    var displayedWidth = state.img.offsetWidth || 0;
    var displayedHeight = state.img.offsetHeight || 0;

    if (displayedWidth <= 1 || displayedHeight <= 1) {
      return MIN_SCALE;
    }

    var naturalWidth = state.img.naturalWidth || displayedWidth;
    var naturalHeight = state.img.naturalHeight || displayedHeight;
    var widthRatio = naturalWidth / displayedWidth;
    var heightRatio = naturalHeight / displayedHeight;
    var nativeRatio = Math.min(widthRatio, heightRatio);

    return clamp(nativeRatio, MIN_SCALE, ABSOLUTE_MAX_SCALE);
  }

  function normalizeScale(state) {
    state.scale = clamp(state.scale, MIN_SCALE, state.maxScale);

    if (state.scale <= MIN_SCALE + 0.01) {
      state.scale = MIN_SCALE;
      state.x = 0;
      state.y = 0;
    }
  }

  function clampPosition(state) {
    var viewport = getViewport(state);
    var scaledWidth = state.img.offsetWidth * state.scale;
    var scaledHeight = state.img.offsetHeight * state.scale;
    var maxX = Math.max(0, (scaledWidth - viewport.width) / 2);
    var maxY = Math.max(0, (scaledHeight - viewport.height) / 2);

    state.x = clamp(state.x, -maxX, maxX);
    state.y = clamp(state.y, -maxY, maxY);
  }

  function hideHint(state) {
    if (!state || !state.hint) return;

    if (state.hintTimer) {
      window.clearTimeout(state.hintTimer);
      state.hintTimer = null;
    }

    state.hint.classList.add('j4u-is-hidden');
    state.hint.setAttribute('aria-hidden', 'true');
  }

  function updateControls(state) {
    if (!state.controls) return;

    var minus = state.controls.querySelector('[data-j4u-zoom="out"]');
    var plus = state.controls.querySelector('[data-j4u-zoom="in"]');
    var canZoom = state.maxScale > MIN_SCALE + 0.01;

    if (minus) minus.disabled = !canZoom || state.scale <= MIN_SCALE + 0.01;
    if (plus) plus.disabled = !canZoom || state.scale >= state.maxScale - 0.01;

    if (canZoom) {
      state.controls.classList.remove('j4u-zoom-unavailable');
    } else {
      state.controls.classList.add('j4u-zoom-unavailable');
      hideHint(state);
    }
  }

  function render(state, animate) {
    if (!state || !state.img) return;

    normalizeScale(state);
    clampPosition(state);

    if (animate) {
      state.img.style.transition = 'transform 160ms ease-out';
      state.img.style.webkitTransition = '-webkit-transform 160ms ease-out';
    } else {
      state.img.style.transition = 'none';
      state.img.style.webkitTransition = 'none';
    }

    var transform =
      'translate3d(' + state.x + 'px,' + state.y + 'px,0) scale(' + state.scale + ')';

    state.img.style.transform = transform;
    state.img.style.webkitTransform = transform;

    if (state.scale > MIN_SCALE + 0.01) {
      state.wrap.classList.add('j4u-is-zoomed');
    } else {
      state.wrap.classList.remove('j4u-is-zoomed');
    }

    updateControls(state);
  }

  function setScaleAtPoint(state, nextScale, clientX, clientY, animate) {
    var previousScale = state.scale;
    var viewport = getViewport(state);
    var pointX = typeof clientX === 'number' ? clientX - viewport.x : 0;
    var pointY = typeof clientY === 'number' ? clientY - viewport.y : 0;
    var sourceX = (pointX - state.x) / previousScale;
    var sourceY = (pointY - state.y) / previousScale;

    state.scale = clamp(nextScale, MIN_SCALE, state.maxScale);

    if (state.scale <= MIN_SCALE + 0.01) {
      state.scale = MIN_SCALE;
      state.x = 0;
      state.y = 0;
    } else {
      state.x = pointX - sourceX * state.scale;
      state.y = pointY - sourceY * state.scale;
    }

    render(state, animate);
  }

  function zoomIn(state, clientX, clientY) {
    setScaleAtPoint(state, state.scale + SCALE_STEP, clientX, clientY, true);
  }

  function zoomOut(state, clientX, clientY) {
    setScaleAtPoint(state, state.scale - SCALE_STEP, clientX, clientY, true);
  }

  function resetZoom(state) {
    setScaleAtPoint(state, MIN_SCALE, null, null, true);
  }

  function toggleZoom(state, clientX, clientY) {
    if (state.maxScale <= MIN_SCALE + 0.01) return;

    if (state.scale <= MIN_SCALE + 0.01) {
      setScaleAtPoint(state, Math.min(2, state.maxScale), clientX, clientY, true);
    } else {
      resetZoom(state);
    }
  }

  function createControls(state) {
    var controls = document.createElement('div');
    controls.className = 'j4u-image-zoom-controls';
    controls.setAttribute('role', 'group');
    controls.setAttribute('aria-label', 'Image zoom controls');
    controls.innerHTML =
      '<button type="button" class="j4u-image-zoom-button" data-j4u-zoom="out" aria-label="Zoom out" title="Zoom out">&minus;</button>' +
      '<button type="button" class="j4u-image-zoom-button" data-j4u-zoom="in" aria-label="Zoom in" title="Zoom in">+</button>';

    var hint = document.createElement('div');
    var coarsePointer =
      window.matchMedia && window.matchMedia('(pointer: coarse)').matches;

    hint.className = 'j4u-image-zoom-hint';
    hint.setAttribute('aria-hidden', 'false');
    hint.textContent = coarsePointer
      ? 'Pinch to zoom · Drag to move'
      : 'Click or scroll to zoom · Drag to move';

    state.wrap.appendChild(controls);
    state.wrap.appendChild(hint);
    state.controls = controls;
    state.hint = hint;

    controls.addEventListener('click', function(event) {
      var action = event.target.getAttribute('data-j4u-zoom');
      if (!action) return;

      event.preventDefault();
      event.stopPropagation();

      if (action === 'in') zoomIn(state);
      if (action === 'out') zoomOut(state);
    });

    state.hintTimer = window.setTimeout(function() {
      hideHint(state);
    }, 4200);
  }

  function removeControls(state) {
    if (state.hintTimer) {
      window.clearTimeout(state.hintTimer);
      state.hintTimer = null;
    }

    if (state.controls && state.controls.parentNode) {
      state.controls.parentNode.removeChild(state.controls);
    }

    if (state.hint && state.hint.parentNode) {
      state.hint.parentNode.removeChild(state.hint);
    }

    state.controls = null;
    state.hint = null;
  }

  function pointerList(state) {
    var list = [];
    var key;

    for (key in state.pointers) {
      if (Object.prototype.hasOwnProperty.call(state.pointers, key)) {
        list.push(state.pointers[key]);
      }
    }

    return list;
  }

  function onPointerDown(event) {
    var state = active;
    var pointers;
    var pinchCenter;
    var viewport;

    if (!state || event.target !== state.img) return;
    if (event.pointerType === 'mouse' && event.button !== 0) return;

    state.pointers[event.pointerId] = {
      x: event.clientX,
      y: event.clientY
    };
    pointers = pointerList(state);

    if (pointers.length === 1) {
      state.pointerStart = { x: event.clientX, y: event.clientY };
      state.lastPointer = { x: event.clientX, y: event.clientY };
      state.didMove = false;
      state.didPinch = false;
    } else if (pointers.length === 2) {
      pinchCenter = center(pointers[0], pointers[1]);
      viewport = getViewport(state);
      state.pinchStartDistance = distance(pointers[0], pointers[1]);
      state.pinchStartScale = state.scale;
      state.pinchSourceX =
        (pinchCenter.x - viewport.x - state.x) / state.scale;
      state.pinchSourceY =
        (pinchCenter.y - viewport.y - state.y) / state.scale;
      state.didPinch = true;
    }

    if (state.scale > MIN_SCALE + 0.01 || pointers.length > 1) {
      event.preventDefault();
      state.wrap.classList.add('j4u-is-dragging');
    }

    if (state.img.setPointerCapture) {
      try {
        state.img.setPointerCapture(event.pointerId);
      } catch (error) {
        // Some browsers reject pointer capture during multi-touch.
      }
    }
  }

  function onPointerMove(event) {
    var state = active;
    if (!state || !state.pointers[event.pointerId]) return;

    state.pointers[event.pointerId] = {
      x: event.clientX,
      y: event.clientY
    };

    var pointers = pointerList(state);

    if (pointers.length >= 2 && state.pinchStartDistance) {
      event.preventDefault();

      var pinchCenter = center(pointers[0], pointers[1]);
      var viewport = getViewport(state);
      var nextScale = clamp(
        state.pinchStartScale *
          distance(pointers[0], pointers[1]) /
          state.pinchStartDistance,
        MIN_SCALE,
        state.maxScale
      );

      state.scale = nextScale;
      state.x =
        pinchCenter.x - viewport.x - state.pinchSourceX * nextScale;
      state.y =
        pinchCenter.y - viewport.y - state.pinchSourceY * nextScale;
      state.didMove = true;
      render(state, false);
      return;
    }

    if (pointers.length === 1 && state.scale > MIN_SCALE + 0.01) {
      event.preventDefault();

      var dx = event.clientX - state.lastPointer.x;
      var dy = event.clientY - state.lastPointer.y;

      if (
        Math.abs(event.clientX - state.pointerStart.x) > 4 ||
        Math.abs(event.clientY - state.pointerStart.y) > 4
      ) {
        state.didMove = true;
      }

      state.x += dx;
      state.y += dy;
      state.lastPointer = { x: event.clientX, y: event.clientY };
      render(state, false);
    }
  }

  function onPointerUp(event) {
    var state = active;
    var pointersBefore;
    var remainingPointers;
    var wasTouchTap;

    if (!state || !state.pointers[event.pointerId]) return;

    pointersBefore = pointerList(state);
    wasTouchTap =
      event.type !== 'pointercancel' &&
      event.pointerType === 'touch' &&
      pointersBefore.length === 1 &&
      !state.didMove &&
      !state.didPinch;

    delete state.pointers[event.pointerId];

    if (state.img.releasePointerCapture) {
      try {
        state.img.releasePointerCapture(event.pointerId);
      } catch (error) {
        // The browser may already have released this pointer.
      }
    }

    remainingPointers = pointerList(state);

    if (remainingPointers.length < 2) {
      state.pinchStartDistance = 0;
    }

    if (remainingPointers.length === 1) {
      state.pointerStart = {
        x: remainingPointers[0].x,
        y: remainingPointers[0].y
      };
      state.lastPointer = {
        x: remainingPointers[0].x,
        y: remainingPointers[0].y
      };

      if (state.scale > MIN_SCALE + 0.01) {
        state.wrap.classList.add('j4u-is-dragging');
      }
    } else {
      state.wrap.classList.remove('j4u-is-dragging');
    }

    if (wasTouchTap) {
      event.preventDefault();
      state.suppressClickUntil = now() + 600;
      toggleZoom(state, event.clientX, event.clientY);
    }

    if (remainingPointers.length === 0 && state.didPinch) {
      state.suppressClickUntil = now() + 600;
      state.didPinch = false;
    }

    render(state, true);
  }

  function closePopup() {
    if (themeJQuery && themeJQuery.magnificPopup) {
      themeJQuery.magnificPopup.close();
      return;
    }

    var closeButton = document.querySelector(
      '.mfp-wrap.j4u-product-lightbox .mfp-close'
    );

    if (closeButton && typeof closeButton.click === 'function') {
      closeButton.click();
    }
  }

  function onFigureClick(event) {
    var state = active;
    if (!state || event.target !== state.figure) return;

    event.preventDefault();
    event.stopPropagation();
    closePopup();
  }

  function onImageClick(event) {
    var state = active;
    if (!state || event.target !== state.img) return;

    event.preventDefault();
    event.stopPropagation();

    if (now() < state.suppressClickUntil) return;

    if (!state.didMove && event.detail <= 1) {
      toggleZoom(state, event.clientX, event.clientY);
    }

    state.didMove = false;
  }

  function onWheel(event) {
    var state = active;
    if (!state || event.target !== state.img) return;

    event.preventDefault();
    event.stopPropagation();

    var delta = event.deltaY;
    if (event.deltaMode === 1) delta *= 16;
    if (event.deltaMode === 2) delta *= window.innerHeight || 800;
    delta = clamp(delta, -240, 240);

    var factor = Math.exp(-delta * 0.0025);
    setScaleAtPoint(
      state,
      state.scale * factor,
      event.clientX,
      event.clientY,
      false
    );
  }

  function onKeyDown(event) {
    var state = active;
    if (!state || event.ctrlKey || event.metaKey || event.altKey) return;

    if (event.key === '+' || event.key === '=') {
      event.preventDefault();
      zoomIn(state);
    } else if (event.key === '-' || event.key === '_') {
      event.preventDefault();
      zoomOut(state);
    } else if (event.key === '0') {
      event.preventDefault();
      resetZoom(state);
    }
  }

  function onImageLoad(event) {
    var state = active;
    if (!state || event.target !== state.img) return;

    var nextSource = imageSource(state.img);
    var sourceChanged = nextSource && nextSource !== state.source;
    state.source = nextSource;
    state.maxScale = calculateMaxScale(state);

    if (sourceChanged) {
      state.scale = MIN_SCALE;
      state.x = 0;
      state.y = 0;
    }

    normalizeScale(state);
    render(state, false);
  }

  function onResize() {
    if (!active) return;

    active.maxScale = calculateMaxScale(active);
    normalizeScale(active);
    render(active, false);
  }

  function onDragStart(event) {
    event.preventDefault();
  }

  function bindState(state) {
    state.figure.addEventListener('click', onFigureClick);
    state.img.addEventListener('pointerdown', onPointerDown);
    state.img.addEventListener('pointermove', onPointerMove);
    state.img.addEventListener('pointerup', onPointerUp);
    state.img.addEventListener('pointercancel', onPointerUp);
    state.img.addEventListener('click', onImageClick, true);
    state.img.addEventListener('wheel', onWheel, false);
    state.img.addEventListener('load', onImageLoad);
    state.img.addEventListener('dragstart', onDragStart);
    document.addEventListener('keydown', onKeyDown);
    window.addEventListener('resize', onResize);
  }

  function unbindState(state) {
    if (!state || !state.img) return;

    state.figure.removeEventListener('click', onFigureClick);
    state.img.removeEventListener('pointerdown', onPointerDown);
    state.img.removeEventListener('pointermove', onPointerMove);
    state.img.removeEventListener('pointerup', onPointerUp);
    state.img.removeEventListener('pointercancel', onPointerUp);
    state.img.removeEventListener('click', onImageClick, true);
    state.img.removeEventListener('wheel', onWheel, false);
    state.img.removeEventListener('load', onImageLoad);
    state.img.removeEventListener('dragstart', onDragStart);
    document.removeEventListener('keydown', onKeyDown);
    window.removeEventListener('resize', onResize);
  }

  function destroyActive() {
    if (!active) return;

    unbindState(active);
    removeControls(active);

    if (active.img) {
      active.img.style.transform = '';
      active.img.style.webkitTransform = '';
      active.img.style.transition = '';
      active.img.style.webkitTransition = '';
    }

    if (active.wrap) {
      active.wrap.classList.remove('j4u-product-zoom');
      active.wrap.classList.remove('j4u-is-zoomed');
      active.wrap.classList.remove('j4u-is-dragging');
    }

    active = null;
  }

  function activate(wrap, img) {
    var nextSource = imageSource(img);

    if (active && active.wrap === wrap && active.img === img) {
      if (nextSource && nextSource !== active.source) {
        active.source = nextSource;
        active.scale = MIN_SCALE;
        active.x = 0;
        active.y = 0;
      }

      active.maxScale = calculateMaxScale(active);
      normalizeScale(active);
      render(active, false);
      return;
    }

    destroyActive();

    var figure = wrap.querySelector('.mfp-figure > figure');
    if (!figure) return;

    active = {
      wrap: wrap,
      figure: figure,
      img: img,
      source: nextSource,
      controls: null,
      hint: null,
      hintTimer: null,
      scale: MIN_SCALE,
      maxScale: MIN_SCALE,
      x: 0,
      y: 0,
      pointers: {},
      pointerStart: { x: 0, y: 0 },
      lastPointer: { x: 0, y: 0 },
      didMove: false,
      didPinch: false,
      pinchStartDistance: 0,
      pinchStartScale: MIN_SCALE,
      pinchSourceX: 0,
      pinchSourceY: 0,
      suppressClickUntil: 0
    };

    wrap.classList.add('j4u-product-zoom');
    createControls(active);
    bindState(active);

    if (img.complete && img.naturalWidth) {
      window.setTimeout(function() {
        if (active && active.img === img) {
          onImageLoad({ target: img });
        }
      }, 0);
    }
  }

  function scanPopup() {
    scanFrame = null;

    var wrap = document.querySelector(
      '.mfp-wrap.j4u-product-lightbox.mfp-gallery'
    );
    var img = wrap ? wrap.querySelector('img.mfp-img') : null;

    if (!wrap || !img) {
      destroyActive();
      return;
    }

    activate(wrap, img);
  }

  function scheduleScan() {
    if (scanFrame !== null) return;
    scanFrame = requestFrame(scanPopup);
  }

  function destroy() {
    if (scanFrame !== null) {
      cancelFrame(scanFrame);
      scanFrame = null;
    }

    destroyActive();
  }

  function init() {
    scheduleScan();
  }

  window.J4UProductImageZoom = {
    refresh: scheduleScan,
    destroy: destroy,
    reset: function() {
      if (active) resetZoom(active);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})(window, document);
